import React from 'react';
import { Container } from '../components/Container';
export function MockupRequest() {
  return <div className="w-full bg-white pb-20" data-id="element-575">
      {/* Header */}
      <div className="bg-[#111827] text-white py-16" data-id="element-576">
        <Container data-id="element-577">
          <div className="max-w-3xl" data-id="element-578">
            <h1 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-4" data-id="element-579">
              Start Your Free Art Mockups
            </h1>
            <div className="w-20 h-1.5 bg-pts-red mb-6" data-id="element-580"></div>
            <p className="text-xl text-gray-300" data-id="element-581">
              Send us your sport, colors, logos, design ideas, and order
              details. Our art team will create initial mockups so you can see
              the direction before moving forward.
            </p>
          </div>
        </Container>
      </div>

      <Container className="py-16" data-id="element-582">
        <div className="max-w-3xl mx-auto" data-id="element-583">
          <form className="space-y-6 bg-gray-50 p-8 rounded-xl border border-gray-200" onSubmit={e => e.preventDefault()} data-id="element-584">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-585">
              <div data-id="element-586">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-587">
                  Name *
                </label>
                <input type="text" required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-588" />
              </div>
              <div data-id="element-589">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-590">
                  Email *
                </label>
                <input type="email" required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-591" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-592">
              <div data-id="element-593">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-594">
                  Phone
                </label>
                <input type="tel" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-595" />
              </div>
              <div data-id="element-596">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-597">
                  Team / Organization Name *
                </label>
                <input type="text" required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-598" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-599">
              <div data-id="element-600">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-601">
                  Sport
                </label>
                <input type="text" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-602" />
              </div>
              <div data-id="element-603">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-604">
                  League / Club / School / Organization
                </label>
                <input type="text" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-605" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-606">
              <div data-id="element-607">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-608">
                  Number of Players / Estimated Quantity
                </label>
                <input type="text" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-609" />
              </div>
              <div data-id="element-610">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-611">
                  Uniform Type
                </label>
                <input type="text" placeholder="e.g. Reversible Jerseys, Full Button" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-612" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-613">
              <div data-id="element-614">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-615">
                  Team Colors
                </label>
                <input type="text" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-616" />
              </div>
              <div data-id="element-617">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-618">
                  Timeline / Needed By Date
                </label>
                <input type="text" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-619" />
              </div>
            </div>

            <div data-id="element-620">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-621">
                Logo Upload / Artwork Files
              </label>
              <input type="file" className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-622" />
              <p className="text-xs text-gray-500 mt-1" data-id="element-623">
                Upload your team logos or design inspiration (JPG, PNG, PDF, AI,
                EPS).
              </p>
            </div>

            <div data-id="element-624">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-625">
                Design Notes / Art Instructions
              </label>
              <textarea rows={4} className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white resize-none" placeholder="Describe what you are looking for..." data-id="element-626"></textarea>
            </div>

            <div className="flex items-center" data-id="element-627">
              <input type="checkbox" id="largeGroup" className="h-4 w-4 text-pts-red focus:ring-pts-red border-gray-300 rounded" data-id="element-628" />
              <label htmlFor="largeGroup" className="ml-2 block text-sm text-gray-700" data-id="element-629">
                Are you part of a league, club, school, or large group?
              </label>
            </div>

            <div data-id="element-630">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-631">
                Additional Notes
              </label>
              <textarea rows={2} className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white resize-none" data-id="element-632"></textarea>
            </div>

            <div className="pt-4" data-id="element-633">
              <button type="submit" className="bg-pts-red hover:bg-pts-red-dark text-white px-8 py-3 rounded font-bold uppercase tracking-wide transition-colors w-full sm:w-auto" data-id="element-634">
                Submit Art Instructions
              </button>
            </div>
          </form>
        </div>
      </Container>
    </div>;
}